/**
 * Created by Bob.Gear on 11/03/14.
 */

// //          if (!Array.prototype.objectPresent) {
// Array.prototype.objectPresent = function (item, comparisonField) {
//   var len = this.length;

//   for (var i = 0; i < len; i++) {
//     if (this[i][comparisonField] == item[comparisonField]) {
//       return true;
//     }
//   }

//   return false;
// }

//          }
//------------------------------------------------------------------------
//  contractorsFilter Directive
//------------------------------------------------------------------------
angular.module("EICDataStream3.queryBuilder")
    .controller('contractorsFilterController', ['$scope', '$http', '$timeout', 'searchService',
      function ($scope, $http, $timeout, searchService) {
        $scope.componentName = "contractorsFilter";

        var objectPresent = function (array, item, comparisonField) {
          var len = array.length;

          for (var i = 0; i < len; i++) {
            if (array[i][comparisonField] == item[comparisonField]) {
              return true;
            }
          }

          return false;
        };

        $scope.availableContractors = [];

        $scope.getContractors = function (inputValue) {
          if (!inputValue) {
            $scope.availableContractors.length = 0;
            return;
          }


          var q = { contractorName: inputValue};

          return $http.get('/api/contractorname', {
            params: {
              limit: 100,
              q:     JSON.stringify(q)
            }
          }).then(function (res) {
                $scope.availableContractors = res.data.filter(function(item){
                  if (!$scope.selectedContractors) return true; // selected contractors do not yet exist, so  select all
 //                 if ($scope.selectedContractors.objectPresent(item, "companyID")) {
                  if (objectPresent($scope.selectedContractors, item, "companyID")) {
                    // object has already been selected; false omits it from the returned list
                    return false;
                  }
                  else{
                    return true;
                  }

                });

              });
        };



        $scope.addCheckedItems = function () {
          // Add the chosen items and automatically select them
          for (var i = 0; i < $scope.candidateContractors.length; i++) {
            var newItem = $scope.candidateContractors[i]
            $scope.selectedContractors.push(newItem)
          }

          // defer the broadcast to  set the checkmarks so the multiselect control
          // can take its turn to set up its internal state
          $timeout(function(){
            $scope.$broadcast('CHECK', {targetControlName: 'ddlSelectedContractors', itemsToCheck: $scope.candidateContractors});

            // is this enough to  remove the checks from the selections?
            $scope.$broadcast('UNCHECK_ALL', {targetControlName:'ddlAvailableContractors'});
            $scope.$broadcast('CLEAR_FILTER');
            $scope.candidateContractors.length = 0;
            $scope.availableContractors.length = 0;
          });
        };

        $scope.selectedContractors = $scope.criteria.selectedContractors || [];
        $scope.candidateContractors = [];


        $scope.biddingStatuses = [
          {id:1, name:"Awarded"},
          {id:2, name:"Unsuccessful"},
          {id:3, name:"Bidding"},
          {id:4, name:"Cancelled"}
        ];

        $scope.contractAwardSearch = searchService.queryDef.searchSubject=="Contract Award";

        $scope.resetFilter = function () {
          $scope.candidateContractors.length = 0;
          $scope.availableContractors.length = 0;

          // fully remove the selected contractors key; it is no longer needed
          $scope.criteria.selectedContractors = null;
          delete $scope.criteria.selectedContractors

          // and bidding statuses
          $scope.criteria.selectedBiddingStatuses = null;
          delete $scope.criteria.selectedBiddingStatuses;
        };

        $scope.removeContractorsFilter = function () {
          $scope.resetFilter();
          $scope.$parent.removeFilter("#contractorsFilter");
        };

      }])
    .directive('contractorsFilter', ['$compile',
      function ($compile) {
        return {
          replace:     true,  // replace the placeholder element with the template
          restrict:    'A',   // usage: <div projectNameFilter />
          templateUrl: "../app-ds3/search/queryBuilder/filters/contractorsFilter.tmpl.html",

          link: function ($scope, iElement, iAttrs) {
          },

          controller: 'contractorsFilterController'
        };
      }]);
//------------------------------------------------------------------------
